import { render, staticRenderFns } from "./PostFormError.vue?vue&type=template&id=73ce0cb2"
import script from "./PostFormError.vue?vue&type=script&lang=ts"
export * from "./PostFormError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports